import React from "react";
import { motion } from "framer-motion";
export function Reveal({
  children,
  className = "",
  delay = 0
}: {
  children: React.ReactNode;
  className?: string;
  delay?: number;
}) {
  return <motion.div initial={{
    opacity: 0,
    y: 24
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.2
  }} transition={{
    duration: 0.55,
    ease: "easeOut",
    delay
  }} className={className} data-id="element-183" data-mp="3bhcm0uwzayuq">
      {children}
    </motion.div>;
}